import { render } from "./ComercialesZero.vue?vue&type=template&id=3dee9ffa&scoped=true"
import script from "./ComercialesZero.vue?vue&type=script&lang=js"
export * from "./ComercialesZero.vue?vue&type=script&lang=js"

import "./ComercialesZero.vue?vue&type=style&index=0&id=3dee9ffa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javier.padilla\\git-repositories\\proyectos.ges.com\\com.ges.proyectos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dee9ffa"]])

export default __exports__